import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { createAction, createFeatureSelector, createReducer, createSelector, on, props } from '@ngrx/store';
import { catchError, map, of, switchMap } from 'rxjs';
import { EdicaoPublicadaPortalOutputDto } from 'src/app/domain/DTOs/output/publicacao/edicao-publicada-portal-output.dto';
import { EdicaoPublicadaService } from 'src/app/services/edicao-publicada.service';
import { CommonMessages } from 'src/app/utils/common.messages';

const actionName = '[Obter Edições Publicadas por Data]';

export const obterEdicoesPublicadasPorData = createAction(`${actionName} Obter`, props<{ dataPublicacao: string }>());
export const obterEdicoesPublicadasPorDataSuccess = createAction(`${actionName} Sucesso`, props<{ response: EdicaoPublicadaPortalOutputDto[] }>());
export const obterEdicoesPublicadasPorDataFailure = createAction(`${actionName} Falha`, props<{ erro: string }>());
export const obterEdicoesPublicadasPorDataFinish = createAction(`${actionName} Concluir`);

export interface ObterEdicoesPublicadasPorDataState {
  response: EdicaoPublicadaPortalOutputDto[] | null;
  error: string | null;
  carregando: boolean;
}

const initialState: ObterEdicoesPublicadasPorDataState = { response: null, error: null, carregando: false };

// -- Reducer
export const obterEdicoesPublicadasPorDataReducer = createReducer(
  initialState,
  on(obterEdicoesPublicadasPorData, state => ({ ...state, response: null, error: null, carregando: true })),
  on(obterEdicoesPublicadasPorDataSuccess, (state, { response }) => ({ ...state, response, error: null, carregando: false })),
  on(obterEdicoesPublicadasPorDataFailure, (state, { erro }) => ({ ...state, response: null, error: erro, carregando: false })),
  on(obterEdicoesPublicadasPorDataFinish, () => initialState)
);

// -- Selector
export const selectObterEdicoesPublicadasPorDataState = createFeatureSelector<ObterEdicoesPublicadasPorDataState>('obterEdicoesPublicadasPorData');
export const selectDadosObterEdicoesPublicadasPorData = createSelector(selectObterEdicoesPublicadasPorDataState, state => state.response);
export const selectCarregandoObterEdicoesPublicadasPorData = createSelector(selectObterEdicoesPublicadasPorDataState, state => state.carregando);
export const selectErrosObterEdicoesPublicadasPorData = createSelector(selectObterEdicoesPublicadasPorDataState, state => state.error);

// -- Effect
@Injectable()
export class ObterEdicoesPublicadasPorDataEffects {
  obterEdicoesPublicadasPorData$ = createEffect(() => this.actions$.pipe(
    ofType(obterEdicoesPublicadasPorData),
    switchMap(({ dataPublicacao }) => this.edicaoPublicadaService.obterEdicoesPorData(dataPublicacao).pipe(
      map(response => response.erros?.length
        ? obterEdicoesPublicadasPorDataFailure({ erro: response.erros[0] })
        : response.dados?.length
          ? obterEdicoesPublicadasPorDataSuccess({ response: response.dados })
          : obterEdicoesPublicadasPorDataFailure({ erro: CommonMessages.EdicaoHtml.SemEdicaoTitulo })),
      catchError(() => of(obterEdicoesPublicadasPorDataFailure({ erro: CommonMessages.EdicaoHtml.CarregarEdicaoPorData })))
    ))
  ));

  constructor(private readonly actions$: Actions, private readonly edicaoPublicadaService: EdicaoPublicadaService) {}
}
